import React, { useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
import { Dialog, DialogContent, Button } from '@material-ui/core'
import { CloudUpload } from '@material-ui/icons'
import { Image, Spinner } from 'ui'
import { observer } from 'mobx-react'
import useStore from 'store'
import { getProtocolPermissions } from './permissions'

import {
  DialogHeaderBlue,
  Header,
  StyledClose,
  StyledIconButton,
  StyledIconButtonWhite,
  CategoryListTitleContainer,
  CategoryListTitleSubContainer1,
  HeaderTitle1,
  NewCategoryBody,
  NewCategoryContainerColumn,
  NewCategoryContainer,
  NewSubCategoryContainer,
} from './CategoryModal.styles'
import { FormInput, FormSelect, FormSearch, UserOption } from './FormComponents'

import ApprovedStatusIcon from 'assets/icons/protocols/icon10.svg'
import RemoveIcon from 'assets/icons/protocols/icon7.svg'
import DocIcon from 'assets/icons/protocols/icon12.svg'
import PrintIcon from 'assets/icons/protocols/icon14.svg'
import AyeIcon from 'assets/icons/protocols/icon25.svg'
import SaveIcon from 'assets/icons/protocols/icon26.svg'
import RejectedStatusIcon from 'assets/icons/protocols/icon27.svg'
import PendingApproveIcon from 'assets/icons/protocols/icon28.svg'
import DraftStatusIcon from 'assets/icons/protocols/icon29.svg'
import Doc2Icon from 'assets/icons/protocols/icon19.svg'
import SecondaryFileIcon from 'assets/icons/protocols/icon23.svg'
import DeleteIcon from 'assets/icons/ims/Delete.svg'

// ─── styled components ────────────────────────────────────────────────────────

const CategoryListTitleSubContainer2 = styled.div`
  display: flex;
  width: 48px;
  height: 48px;
  padding: 12px;
  flex-direction: column;
  align-items: flex-start;
  flex-shrink: 0;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.20);
`
const HeaderTitle2 = styled.div`
  display: flex;
  color: #F3E8FF;
  font-family: Rubik;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
`
const HeaderDialogButton = styled(Button)`
  display: flex;
  height: 39.986px;
  margin-right: 10px;
  padding-left: 15.994px;
  align-items: center;
  gap: 7.997px;
  flex-shrink: 0;
  border-radius: 8px;
  background: #9810FA;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.10), 0 2px 4px -2px rgba(0, 0, 0, 0.10);
  color: #FFF;
  text-align: center;
  font-family: Rubik;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
`
const MetaItem = styled.span`
  display: flex;
  align-items: center;
  gap: 4px;
`
const ImageHeaderBlue = styled(Image)`
  padding-left: 5px;
`
const ImageHeader = styled(Image)`
  display: flex;
`
const ProtocolEditContainer = styled.div`
  border-radius: 8px;
  padding: 32px 50px;
  border: 0.909px solid #E5E7EB;
  background: #FFF;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.10), 0 1px 2px -1px rgba(0, 0, 0, 0.10);
`
const CloseButton = styled(Button)`
  border-radius: 8px;
  background: #E5E7EB;
  display: flex;
  padding: 8px 24px;
  justify-content: center;
  align-items: center;
  color: #364153;
  text-align: center;
  font-family: Rubik;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
`
export const ProtocolContainerActions = styled.div`
  border-top: 0.909px solid #E5E7EB;
  width: 100%;
  display: flex;
  height: 58.707px;
  justify-content: flex-end;
  align-items: center;
  gap: 11.989px;
  flex-shrink: 0;
  align-self: stretch;
`
const SpinnerWrap = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 48px 0;
  width: 100%;
`
const StyledDateInput = styled.input`
  display: flex;
  height: 41.804px;
  padding: 8px 16px;
  justify-content: flex-end;
  align-items: center;
  flex-shrink: 0;
  align-self: stretch;
  border-radius: 8px;
  border: 0.909px solid #D1D5DC;
  color: rgba(15, 23, 42, 0.70);
  text-align: right;
  font-family: Rubik;
  font-size: 16px;
  font-weight: 400;
  outline: none;
  width: 100%;
  box-sizing: border-box;
`
const FieldLabel = styled.div`
  color: #364153;
  font-family: Rubik;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  text-align: right;
  width: 100%;
`
const FieldRequired = styled.span`
  color: #364153;
  margin-left: 2px;
`
const FieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
  align-self: stretch;
  width: 100%;
`
const StyledTextarea = styled.textarea`
  display: flex;
  width: 100%;
  min-height: 120px;
  padding: 12px 16px;
  border-radius: 8px;
  border: 0.909px solid #D1D5DC;
  color: rgba(15, 23, 42, 0.70);
  text-align: right;
  font-family: Rubik;
  font-size: 16px;
  font-weight: 400;
  line-height: 1.6;
  resize: vertical;
  outline: none;
  box-sizing: border-box;
  direction: rtl;
`
const SectionLabel = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-start;
  align-items: center;
  color: #101828;
  font-family: Rubik;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  direction: rtl;
`
// File section
const FileSectionTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: #101828;
  font-family: Rubik;
  font-size: 15px;
  font-weight: 600;
  direction: rtl;
  width: 100%;
`
const MainFileCard = styled.div`
  display: flex;
  width: 100%;
  padding: 16px 20px;
  justify-content: space-between;
  align-items: center;
  border-radius: 8px;
  border: 1.818px solid #51A2FF;
  background: linear-gradient(90deg, #EFF6FF 0%, #DBEAFE 100%);
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.10), 0 1px 2px -1px rgba(0, 0, 0, 0.10);
  direction: rtl;
`
const MainFileInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  flex: 1;
`
const MainFileName = styled.div`
  color: #101828;
  font-family: Rubik;
  font-size: 15px;
  font-weight: 700;
  line-height: 24px;
`
const MainFileSize = styled.div`
  color: #364153;
  font-family: Rubik;
  font-size: 13px;
  font-weight: 400;
`
const MainFileIconBox = styled.div`
  display: flex;
  width: 40px;
  height: 40px;
  padding: 10px;
  margin-left: 12px;
  flex-direction: column;
  align-items: flex-start;
  flex-shrink: 0;
  border-radius: 8px;
`
const SecondaryFileCard = styled.div`
  display: flex;
  width: 100%;
  padding: 12px 16px;
  justify-content: space-between;
  align-items: center;
  border-radius: 8px;
  border: 0.909px solid #E5E7EB;
  background: #F9FAFB;
  direction: rtl;
  box-sizing: border-box;
`
const SecondaryFileInfo = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  gap: 10px;
  flex: 1;
`
const SecondaryFileName = styled.div`
  color: #101828;
  font-family: Rubik;
  font-size: 14px;
  font-weight: 500;
`
const SecondaryFileSize = styled.div`
  color: #64748B;
  font-family: Rubik;
  font-size: 12px;
`
const SecondaryFileIconBox = styled.div`
  display: flex;
  width: 32px;
  height: 32px;
  padding: 8px;
  flex-shrink: 0;
  border-radius: 6px;
  margin-left: 8px;
`
const UploadZone = styled.label`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 20px 16px;
  border-radius: 8px;
  border: 1.5px dashed #D1D5DC;
  background: #F8FAFC;
  cursor: pointer;
  box-sizing: border-box;
  &:hover {
    border-color: #155DFC;
    background: #EFF6FF;
  }
`
const UploadText = styled.div`
  color: #64748B;
  font-family: Rubik;
  font-size: 14px;
  font-weight: 400;
  text-align: center;
`
const UploadFileName = styled.div`
  color: #155DFC;
  font-family: Rubik;
  font-size: 13px;
  font-weight: 400;
  text-align: center;
  margin-top: 4px;
`
const HiddenInput = styled.input`
  display: none;
`
const NewBadge = styled.span`
  display: inline-flex;
  padding: 2px 8px;
  color: #008236;
  font-family: Rubik;
  font-size: 11px;
  font-weight: 600;
  line-height: 16px;
  flex-shrink: 0;
`
const ActionsImage = styled(Image)`
  width: 16px;
  height: 16px;
`
const StatusTitle = styled.div`
  display: flex;
  width:100%;
  padding: 0 1px 0 1px;
  justify-content: flex-start;
  align-items: flex-end;
  gap: 3.082px;
  align-self: stretch;
`
const StatusContent = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: flex-start;
  gap: 11.989px;
  flex-shrink: 0;
  align-self: stretch;
`
const StatusCard = styled.div<{ selected?: boolean; selectedBg?: string; selectedColor?: string; selectedBorder?: string; disabled?: boolean }>`
  display: flex;
  flex: 1;
  height: 51.605px;
  padding: 8px 16px;
  justify-content: center;
  align-items: center;
  gap: 7.679px;
  border-radius: 8px;
  border: 1.5px solid ${p => p.disabled ? '#E5E7EB' : p.selected ? p.selectedBorder : '#D1D5DC'};
  background: ${p => p.disabled ? '#F9FAFB' : p.selected ? p.selectedBg : '#fff'};
  color: ${p => p.disabled ? '#C0C7D0' : p.selected ? p.selectedColor : '#4A5565'};
  text-align: center;
  font-family: Rubik;
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  cursor: ${p => p.disabled ? 'not-allowed' : 'pointer'};
  transition: background 0.15s;
  &:hover {
    border: 1.5px solid ${p => p.disabled ? '#E5E7EB' : p.selectedBorder};
  }
`

// ─── helpers ─────────────────────────────────────────────────────────────────

const formatFileSize = (bytes: number): string => {
  if (!bytes) return ''
  if (bytes < 1024) return `${bytes} B`
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`
}

const toTextarea = (val: string) => val ? val.split(';').join('\n') : ''
const fromTextarea = (val: string) => val.split('\n').join(';')

const toDateInputValue = (isoString: string): string => {
  if (!isoString) return ''
  return isoString.substring(0, 10)
}

// ─── component ───────────────────────────────────────────────────────────────

const ProtocolEditModal = ({ open, protocolId, statusOnly = false, onClose, onSaved }: { open: boolean; protocolId: number | null; statusOnly?: boolean; onClose: () => void; onSaved?: () => void }) => {
  const { orgs, protocolsStore } = useStore()
  const data = protocolsStore.protocolEdit
  const loading = protocolsStore.loadingProtocolEdit
  const perms = getProtocolPermissions(protocolsStore.userPermissions)

  const [title, setTitle] = useState('')
  const [categoryId, setCategoryId] = useState('')
  const [date, setDate] = useState('')
  const [participants, setParticipants] = useState<UserOption[]>([])
  const [topics, setTopics] = useState('')
  const [decisions, setDecisions] = useState('')
  const [description, setDescription] = useState('')
  const [protocolStatusId, setProtocolStatusId] = useState(1)
  const [deletedFileIds, setDeletedFileIds] = useState<number[]>([])
  const [newMainFile, setNewMainFile] = useState<File | null>(null)
  const [newAttachments, setNewAttachments] = useState<File[]>([])
  const [rejectReason, setRejectReason] = useState('')
  const [saving, setSaving] = useState(false)

  const mainFileRef = useRef<HTMLInputElement>(null)
  const attachmentsRef = useRef<HTMLInputElement>(null)

  useEffect(() => {
    if (open) {
      protocolsStore.loadUserList()
      protocolsStore.loadCategories(orgs.currentOrgId)
    }
  }, [open])

  useEffect(() => {
    if (data) {
      setTitle(data.title || '')
      setCategoryId(data.categoryId ? String(data.categoryId) : '')
      setDate(toDateInputValue(data.protocolDate))
      setParticipants(
        data.participants.map(p => ({ userId: p.userId, fullName: p.participantName }))
      )
      setTopics(data.topics || '')
      setDecisions(data.decisions || '')
      setDescription(data.description || '')
      setProtocolStatusId(data.protocolStatusId || 1)
      setRejectReason('')
      setDeletedFileIds([])
      setNewMainFile(null)
      setNewAttachments([])
    }
  }, [data])

  const handleClose = () => {
    onClose()
  }

  const handleSave = async () => {
    if (!protocolId) return
    setSaving(true)

    const res = await protocolsStore.updateProtocol(protocolId, {
      title,
      protocolDate: date ? new Date(date).toISOString() : '',
      newCategoryId: Number(categoryId),
      protocolStatusId,
      participants: participants.map(p => ({
        userId: p.userId,
        participantRole: data?.participants.find(dp => dp.userId === p.userId)?.participantRole || '',
      })),
      topics,
      decisions,
      description,
      isPublic: data?.isPublic ?? false,
    })

    if (res) {
      if (protocolStatusId === 4 && data?.protocolStatusId !== 4) {
        await protocolsStore.updateProtocolStatus(protocolId, { protocolStatusId: 4, rejectReason })
      }
      const filesToUpload = [
        ...(newMainFile ? [{ file: newMainFile, isMainFile: true }] : []),
        ...newAttachments.map(f => ({ file: f, isMainFile: false })),
      ]
      if (deletedFileIds.length > 0 || filesToUpload.length > 0) {
        await protocolsStore.deleteProtocolFiles(protocolId, deletedFileIds, filesToUpload)
      }
      handleClose()
      onSaved?.()
    }

    setSaving(false)
  }

  const modifiedStr = data?.modifiedDate ? new Date(data.modifiedDate).toLocaleDateString('he-IL') : ''

  return (
    <Dialog style={{ zIndex: 1200 }} open={open} fullWidth maxWidth="md" scroll="body">
      <DialogHeaderBlue>
        <Header style={{ background: 'linear-gradient(90deg, #9810FA 0%, #8200DB 100%)' }}>
          <CategoryListTitleContainer>
            <CategoryListTitleSubContainer2>
              <ImageHeader src={DocIcon} />
            </CategoryListTitleSubContainer2>
            <CategoryListTitleSubContainer1>
              <HeaderTitle1 style={{ color: 'white' }}>
                {statusOnly ? 'עדכון סטטוס פרוטוקול' : (data?.title || 'עריכת פרוטוקול')}
              </HeaderTitle1>
              <HeaderTitle2>
                {data?.version && <MetaItem>גרסה {data.version} • </MetaItem>}
                {modifiedStr && <MetaItem>עדכון אחרון: {modifiedStr}</MetaItem>}
              </HeaderTitle2>
            </CategoryListTitleSubContainer1>
          </CategoryListTitleContainer>
          {/*<>
          {!statusOnly && <HeaderDialogButton><ImageHeaderBlue src={AyeIcon} /> צפה בפרוטוקול</HeaderDialogButton>}
          {!statusOnly && <HeaderDialogButton><ImageHeaderBlue src={PrintIcon} /> שתף פרוטוקול</HeaderDialogButton>}
          </>*/}
          <StyledIconButtonWhite onClick={handleClose}><StyledClose /></StyledIconButtonWhite>
        </Header>
      </DialogHeaderBlue>

      <DialogContent>
        <ProtocolEditContainer>
          {loading && <SpinnerWrap><Spinner /></SpinnerWrap>}

          {!loading && data && (
            <NewCategoryBody>

              {/* Title */}
              {!statusOnly && (
                <NewCategoryContainer>
                  <NewSubCategoryContainer style={{ height: 'auto', width: '100%' }}>
                    <FormInput
                      label="כותרת הפרוטוקול"
                      required
                      value={title}
                      onChange={setTitle}
                      placeholder="פרוטוקול אפריל 2024"
                    />
                  </NewSubCategoryContainer>
                </NewCategoryContainer>
              )}

              {/* Category + Date */}
              {!statusOnly && (
                <NewCategoryContainer style={{ marginTop: '16px' }}>
                  <NewSubCategoryContainer style={{ height: 'auto', width: '50%' }}>
                    <FormSelect
                      label="קטגוריה"
                      required
                      value={categoryId}
                      onChange={setCategoryId}
                      options={[
                        { value: '', label: 'בחר קטגוריה' },
                        ...protocolsStore.categories.map(c => ({ value: String(c.id), label: c.categoryName })),
                      ]}
                    />
                  </NewSubCategoryContainer>
                  <NewSubCategoryContainer style={{ height: 'auto' }}>
                    <FieldWrapper>
                      <FieldLabel>תאריך הפרוטוקול<FieldRequired>*</FieldRequired></FieldLabel>
                      <StyledDateInput
                        type="date"
                        value={date}
                        max={new Date().toISOString().split('T')[0]}
                        onChange={e => setDate(e.target.value)}
                      />
                    </FieldWrapper>
                  </NewSubCategoryContainer>
                </NewCategoryContainer>
              )}

              <NewCategoryContainer style={{ borderRadius: '8px', border: '2px solid #BEDBFF', background: '#EFF6FF', flexDirection: 'column', gap: '8px', padding: '12px' }}>
                <StatusTitle>סטטוס הפרוטוקול</StatusTitle>
                <StatusContent>
                  {[
                    { title: 'מאושר', value: 3, icon: ApprovedStatusIcon, selectedBg: '#dcfce7', selectedColor: '#0d542b', selectedBorder: '#00c951', approvingOnly: true },
                    { title: 'נדחה', value: 4, icon: RejectedStatusIcon, selectedBg: '#ffe2e2', selectedColor: '#82181a', selectedBorder: '#fb2c36', approvingOnly: true },
                    { title: 'ממתין לאישור', value: 2, icon: PendingApproveIcon, selectedBg: '#FEF9C2', selectedColor: '#733E0A', selectedBorder: '#F0B100', approvingOnly: false },
                    { title: 'טיוטה', value: 1, icon: DraftStatusIcon, selectedBg: '#f6f3f4', selectedColor: '#101828', selectedBorder: '#6a7282', approvingOnly: false },
                  ].map(item => {
                    const isDisabled = item.approvingOnly && !perms.isApprovingManager
                    return (
                      <StatusCard
                        key={item.value}
                        selected={protocolStatusId === item.value}
                        selectedBg={item.selectedBg}
                        selectedColor={item.selectedColor}
                        selectedBorder={item.selectedBorder}
                        disabled={isDisabled}
                        onClick={() => !isDisabled && setProtocolStatusId(item.value)}
                      >
                        <ImageHeader src={item.icon} style={{ width: 18, height: 18 }} />
                        {item.title}
                      </StatusCard>
                    )
                  })}
                </StatusContent>
              </NewCategoryContainer>

              {/* Reject reason */}
              {protocolStatusId === 4 && (
                <NewCategoryContainerColumn style={{ marginTop: '16px' }}>
                  <FieldWrapper>
                    <FieldLabel>סיבת דחייה<FieldRequired>*</FieldRequired></FieldLabel>
                    <StyledTextarea
                      value={rejectReason}
                      onChange={e => setRejectReason(e.target.value)}
                      placeholder="נא לפרט את הסיבה לדחיית המסמך..."
                      dir="rtl"
                    />
                  </FieldWrapper>
                </NewCategoryContainerColumn>
              )}

              {/* Participants */}
              {!statusOnly && (
                <NewCategoryContainerColumn style={{ marginTop: '16px' }}>
                  <SectionLabel>משתתפים</SectionLabel>
                  <FormSearch
                    label=""
                    value={participants}
                    onChange={setParticipants}
                    options={protocolsStore.userList}
                    placeholder="חפש משתתף..."
                  />
                </NewCategoryContainerColumn>
              )}

              {/* Topics */}
              {!statusOnly && (
                <NewCategoryContainerColumn style={{ marginTop: '16px' }}>
                  <FieldWrapper>
                    <FieldLabel>נושאי דיון</FieldLabel>
                    <StyledTextarea
                      value={toTextarea(topics)}
                      onChange={e => setTopics(fromTextarea(e.target.value))}
                      placeholder="הזן נושאי דיון..."
                      dir="rtl"
                    />
                  </FieldWrapper>
                </NewCategoryContainerColumn>
              )}

              {/* Decisions */}
              {!statusOnly && (
                <NewCategoryContainerColumn style={{ marginTop: '16px' }}>
                  <FieldWrapper>
                    <FieldLabel>החלטות</FieldLabel>
                    <StyledTextarea
                      value={toTextarea(decisions)}
                      onChange={e => setDecisions(fromTextarea(e.target.value))}
                      placeholder="הזן החלטות..."
                      dir="rtl"
                    />
                  </FieldWrapper>
                </NewCategoryContainerColumn>
              )}

              {/* Description */}
              {!statusOnly && (
                <NewCategoryContainerColumn style={{ marginTop: '16px' }}>
                  <FieldWrapper>
                    <FieldLabel>תוכן הפרוטוקול<FieldRequired>*</FieldRequired></FieldLabel>
                    <StyledTextarea
                      value={description}
                      onChange={e => setDescription(e.target.value)}
                      placeholder="הזן את תוכן הפרוטוקול..."
                      dir="rtl"
                    />
                  </FieldWrapper>
                </NewCategoryContainerColumn>
              )}

              {/* Main file */}
              {!statusOnly && <NewCategoryContainerColumn style={{ marginTop: '24px' }}>
                <FileSectionTitle>
                  <ImageHeader src={DocIcon} style={{ width: 18, height: 18 }} />
                  קובץ ראשי
                </FileSectionTitle>

                {data.mainFile && !newMainFile && !deletedFileIds.includes(data.mainFile.id) && (
                  <MainFileCard>
                    <MainFileIconBox>
                      <ImageHeader src={Doc2Icon} />
                    </MainFileIconBox>
                    <MainFileInfo>
                      <MainFileName>{data.mainFile.fileName}</MainFileName>
                      <MainFileSize>{formatFileSize(data.mainFile.fileSize)}</MainFileSize>
                    </MainFileInfo>
                    <StyledIconButton onClick={() => setDeletedFileIds(prev => [...prev, data.mainFile!.id])}>
                      <ActionsImage src={RemoveIcon} />
                    </StyledIconButton>
                  </MainFileCard>
                )}

                {newMainFile && (
                  <MainFileCard>
                    <MainFileIconBox>
                      <ImageHeader src={Doc2Icon} />
                    </MainFileIconBox>
                    <MainFileInfo>
                      <MainFileName>{newMainFile.name} <NewBadge>חדש</NewBadge></MainFileName>
                      <MainFileSize>{formatFileSize(newMainFile.size)}</MainFileSize>
                    </MainFileInfo>
                    <StyledIconButton onClick={() => setNewMainFile(null)}>
                      <ActionsImage src={RemoveIcon} />
                    </StyledIconButton>
                  </MainFileCard>
                )}

                <FieldWrapper>
                  <UploadZone>
                    <HiddenInput
                      ref={mainFileRef}
                      type="file"
                      accept=".pdf,.doc,.docx"
                      onChange={e => setNewMainFile(e.target.files?.[0] || null)}
                    />
                    <CloudUpload style={{ color: '#94A3B8', fontSize: 28 }} />
                    <UploadText>
                      {data.mainFile ? 'העלה קובץ פרוטוקול ראשי' : 'לחץ להעלאת קובץ או גרור לכאן'}
                    </UploadText>
                  </UploadZone>
                </FieldWrapper>
              </NewCategoryContainerColumn>}

              {/* Attachments */}
              {!statusOnly && <NewCategoryContainerColumn style={{ marginTop: '24px' }}>
                <FileSectionTitle>
                  <ImageHeader src={SecondaryFileIcon} style={{ width: 18, height: 18 }} />
                  קבצים מצורפים
                </FileSectionTitle>

                {data.attachments.filter(f => !deletedFileIds.includes(f.id)).map(file => (
                  <SecondaryFileCard key={file.id}>
                    <SecondaryFileIconBox>
                      <ImageHeader src={SecondaryFileIcon} />
                    </SecondaryFileIconBox>
                    <SecondaryFileInfo>
                      <SecondaryFileName>{file.fileName}</SecondaryFileName>
                      <SecondaryFileSize>{formatFileSize(file.fileSize)}</SecondaryFileSize>
                    </SecondaryFileInfo>
                    <StyledIconButton onClick={() => setDeletedFileIds(prev => [...prev, file.id])}>
                      <ActionsImage src={RemoveIcon} />
                    </StyledIconButton>
                  </SecondaryFileCard>
                ))}

                {newAttachments.map((file, i) => (
                  <SecondaryFileCard key={i} style={{ border: '1px solid #B9F8CF', background: '#F0FDF4' }}>
                    <SecondaryFileIconBox>
                      <ImageHeader src={SecondaryFileIcon} style={{ filter: 'invert(46%) sepia(98%) saturate(432%) hue-rotate(100deg) brightness(95%) contrast(103%)' }} />
                    </SecondaryFileIconBox>
                    <SecondaryFileInfo>
                      <SecondaryFileName>{file.name} <NewBadge>חדש</NewBadge></SecondaryFileName>
                      <SecondaryFileSize>{formatFileSize(file.size)}</SecondaryFileSize>
                    </SecondaryFileInfo>
                    <StyledIconButton onClick={() => setNewAttachments(prev => prev.filter((_, j) => j !== i))}>
                      <ActionsImage src={RemoveIcon} />
                    </StyledIconButton>
                  </SecondaryFileCard>
                ))}

                <FieldWrapper>
                  <UploadZone>
                    <HiddenInput
                      ref={attachmentsRef}
                      type="file"
                      multiple
                      onChange={e => setNewAttachments(prev => [...prev, ...Array.from(e.target.files || [])])}
                    />
                    <CloudUpload style={{ color: '#94A3B8', fontSize: 28 }} />
                    <UploadText>העלאת קבצים נוספים</UploadText>
                  </UploadZone>
                </FieldWrapper>
              </NewCategoryContainerColumn>}

            </NewCategoryBody>
          )}
        </ProtocolEditContainer>

        <ProtocolContainerActions style={{ paddingRight: 0 }}>
          <CloseButton onClick={handleClose}>סגור</CloseButton>
          <HeaderDialogButton onClick={handleSave} disabled={saving || (!statusOnly && !title.trim()) || (protocolStatusId === 4 && !rejectReason.trim())}>
            {saving ? <Spinner size={16} /> : <><ImageHeaderBlue src={SaveIcon} /> שמור שינויים</>}
          </HeaderDialogButton>
        </ProtocolContainerActions>
      </DialogContent>
    </Dialog>
  )
}

export default observer(ProtocolEditModal)
